import './footer.scss';
import facebookIcon from '../../../assets/icon-facebook.svg';
import instagramIcon from '../../../assets/icon-instagram.svg';
import Accordion from '../../atoms/accordion/accordion';
import logoSuperSubsidio from '../../../assets/logoSuperSubsidio.svg';

const urlAmbiente = window.location;
const urlTYC = `${urlAmbiente.origin}/mentoria-financiera/tyc`;

const linksComfama = [
  {
    title: 'Conoce Comfama',
    redirectURL: 'https://www.comfama.com/',
  },
];

const mentoriaFinanciera = [
  {
    title: '¿Qué es la mentoría financiera?',
    redirectURL: 'https://www.comfama.com/finanzas/landing-mentoria-financiera/',
  },
  {
    title: 'Términos y condiciones',
    redirectURL: urlTYC,
  },
];

const teAcompanamos = [
  {
    title: '¿Necesitas ayuda?',
    redirectURL: 'https://forms.office.com/r/R1QEmkEEwb',
  },
  {
    title: 'Contáctanos',
    redirectURL: 'https://forms.office.com/r/R1QEmkEEwb',
  },
];

const Footer = () => {
  return (
    <div className="t-footer" data-testid="footer-container">
      <div className="t-footer__head-container">
        <Accordion title="Comfama" links={linksComfama} />
        <Accordion title="Mentoría financiera" links={mentoriaFinanciera} />
        <Accordion title="Te acompañamos" links={teAcompanamos} />
      </div>
      <div className="t-footer__head-container-desktop">
        <div className="t-footer__head-container-desktop__section">
          <h3>Comfama</h3>
          {linksComfama.map(link => (
            <a key={link.title} href={link.redirectURL} rel="noreferrer" target="_blank">
              {link.title}
            </a>
          ))}
        </div>
        <div className="t-footer__head-container-desktop__section">
          <h3>Mentoría financiera</h3>
          {mentoriaFinanciera.map(link => (
            <a key={link.title} href={link.redirectURL} rel="noreferrer" target="_blank">
              {link.title}
            </a>
          ))}
        </div>
        <div className="t-footer__head-container-desktop__section">
          <h3>Te acompañamos</h3>
          {teAcompanamos.map(link => (
            <a key={link.title} href={link.redirectURL} rel="noreferrer" target="_blank">
              {link.title}
            </a>
          ))}
        </div>
        <div className="t-footer__head-container-desktop__section-media">
          <h3>Síguenos en redes sociales</h3>
          <div>
            <a href="https://www.facebook.com/comfamaservifinancieros/" rel="noreferer" target="_blank">
              <img src={facebookIcon} alt="Facebook Mentoria Financiera" />
            </a>
            <a href="https://www.instagram.com/comfamaserviciosfinancieros/" rel="noreferer" target="_blank">
              <img src={instagramIcon} alt="Instagram Mentoria Financiera" />
            </a>
          </div>
        </div>
      </div>
      <div className="t-footer__social-media">
        <p className="t-footer__social-media__title">Síguenos en redes sociales</p>
        <div className="t-footer__social-media__icons">
          <a href="https://www.facebook.com/comfamaservifinancieros/" rel="noreferer" target="_blank">
            <img src={facebookIcon} alt="Facebook Mentoria Financiera" />
          </a>
          <a href="https://www.instagram.com/comfamaserviciosfinancieros/" rel="noreferer" target="_blank">
            <img src={instagramIcon} alt="Instagram Mentoria Financiera" />
          </a>
        </div>
      </div>
      <div className="t-footer-bottom">
        <div>
          <p className="t-footer-bottom__title">Comfama es un sitio seguro</p>
          <img
            className="t-footer-bottom__pacto-global"
            src="https://images.ctfassets.net/gkhyeghj07ak/5kmPYnt93yGiBLSIh0Bn6t/b9bab0763df58cdc9b49ea3cf4377b3a/logo-red-pacto-global-black.webp"
            alt="Pacto global Red Colombia"
          />
          <p className="t-footer-bottom__subtitle">
            Este sitio funciona mejor con las últimas versiones de Microsoft Edge, Google Chrome y Firefox.
          </p>
          <p className="t-footer-bottom__subtitle">
            <b>Copyright © 2020</b> Comfama Todos los derechos reservados Medellín - Colombia
          </p>
        </div>
        <div className="t-footer-bottom__images">
          <div className="t-footer-bottom__images__image1">
            <img
              src="https://images.ctfassets.net/gkhyeghj07ak/15XAKA9ySrg9NmEZSdfHMC/cb96acb5566accd22d803093fc930682/gray.svg"
              alt="Comfama"
            />
          </div>
          <div className="t-footer-bottom__images__image2">
            <img
              src={logoSuperSubsidio}
              alt="Vigilado Supersubsidio"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
